export default __webpack_public_path__ + "static/vello-crespo-960029416581fd225e48338aa48d204f.svg";